exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-uploader .el-upload[data-v-a8e42f5a]{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-a8e42f5a]:hover{border-color:#409EFF}.avatar[data-v-a8e42f5a]{width:100px;height:100px;display:block}.avatar-uploader-icon[data-v-a8e42f5a]{font-size:28px;color:#8c939d;width:100px;height:100px;line-height:100px;text-align:center}\n", ""]);

// exports
